import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { showToast } from "../../../utils/ToastHelper";
import { BASE_URL } from "../../Const/Url";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import swal from "sweetalert";
import Loader from "../../CustomCommons/Loader";
import { logout_func3 } from "../../Const/logoutCommon";

const CatalogExport = () => {
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [hasSelected, setHasSelected] = useState(false);
  const history = useHistory();

  const url = `${BASE_URL}api/v1/inventory/admin/catalog-product-export/`;
  const categoriesUrl = `${BASE_URL}api/v1/inventory/inventory/category?limit=2000&query=`;

  const exportUrl = category === "" ? url : `${url}?category=${parseInt(category)}`;

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(exportUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories("");
  }, []);

  // Fetch categories when search term changes (with debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchCategories(searchTerm);
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownContainer = document.querySelector('.category-dropdown-container');
      if (dropdownContainer && !dropdownContainer.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const fetchCategories = (searchQuery = "") => {
    setIsLoadingCategories(true);
    const url = `${BASE_URL}api/v1/inventory/inventory/category?limit=2000&query=${encodeURIComponent(searchQuery)}`;
    
    axios
      .get(url)
      .then((res) => {
        if (res.data.status === "success") {
          const activeCategories = res.data.data.results.filter(cat => cat.is_active);
          // Add All Categories option at the top
          const allOption = [{
            id: "",
            name: "All Categories",
            products: null,
            stock: null,
            thumb_url: null,
          }];
          setCategories([...allOption, ...activeCategories]);
          setFilteredCategories([...allOption, ...activeCategories]);
        }
        setIsLoadingCategories(false);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setIsLoadingCategories(false);
        showToast("error", "Failed to load categories");
      });
  };

  const handleExport = () => {
    if (category === undefined || category === null) {
      showToast("error", "Please select a category");
      return;
    }

    SetisLoading(true);

    axios
      .get(exportUrl, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then((res) => {
        // Create a download link for the exported CSV file
        const blob = new Blob([res.data], { 
          type: 'text/csv' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const selectedCategory = categories.find(cat => cat.id.toString() === category);
        const categoryName = selectedCategory ? selectedCategory.name.replace(/[^a-zA-Z0-9]/g, '_') : category;
        link.download = `catalog-export-${categoryName}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        showToast("success", "Catalog exported successfully!");
        SetisLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log("errorMsg", errorMsg);
        var errors = "Please, Try again, after Solving this errors: \n \n ";
        for (let key in errorMsg) {
          errors += errorMsg[key];
          errors += "\n";
          errors += "\n";
        }
        swal({
          icon: "error",
          text: errors,
        });
        SetisLoading(false);
        if (
          message === "Invalid token." ||
          JSON.parse(err?.request?.response)?.code === 401
        ) {
          logout_func3(history);
        }
      });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      className="categorey-parent pd-right"
      style={{ height: "100vh", background: "#FAFAFA" }}
    >
      <div className="bg-white mb-3">
        <div
          className=""
          style={{ padding: "20px 35px ", border: "0.5px solid #E0E0E0" }}
        >
          <h3 className="head-tag" style={{ marginBottom: "20px" }}>
            Catalog Export Instructions
          </h3>
          <div className="inst mb-4" style={{ color: "#828282" }}>
            <p className="my-2">
              1. Use the search box to find the category you want to export, or browse through the list.
            </p>
            <p className="my-2">
              2. Click on a category to select it (it will be highlighted in blue).
            </p>
            <p className="my-2">
              3. Click the Export button to download the catalog as a CSV file.
            </p>
            <p className="my-2">
              4. The exported file will contain all product details for the selected category.
            </p>
            <p className="my-2">
              5. The file will be automatically downloaded with the category name.
            </p>
            <p className="my-2">
              6. You can see product count and stock information for each category.
            </p>
          </div>
        </div>
      </div>

      {/* ======export=========== */}
      <div className="bg-white">
        <div
          className="side-pd"
          style={{ border: "0.5px solid #E0E0E0" }}
        >
          <h3
            className="h5-head"
            style={{ marginTop: "6px", marginLeft: "12px" }}
          >
            Export Product Catalog
          </h3>
        </div>
        
        <div className="side-pd bord">
          <RequiredLabel text={"Category"} />
          <div className="row">
            <div className="col-11 col-lg-6 col-md-8">
              {isLoadingCategories ? (
                <div className="d-flex align-items-center" style={{ height: "55px" }}>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span>Loading categories...</span>
                </div>
              ) : (
                <>
                  <div className="position-relative category-dropdown-container">
                    <div className="d-flex align-items-center border rounded" style={{ border: "1px solid #E0E0E0" }}>
                      <input
                        type="text"
                        className="form-control border-0"
                        placeholder={
                          category === ""
                            ? "All Categories"
                            : categories.find(cat => cat.id?.toString() === category)?.name || "Search categories..."
                        }
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onFocus={() => setIsDropdownOpen(true)}
                        style={{
                          height: "55px",
                          borderRadius: "7px",
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-link border-0"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        style={{ minWidth: "40px" }}
                      >
                        <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}></i>
                      </button>
                    </div>
                    
                    {isDropdownOpen && (
                      <div 
                        className="border rounded position-absolute w-100 bg-white"
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #E0E0E0",
                          zIndex: 1000,
                          top: "100%",
                          left: 0,
                          right: 0,
                        }}
                      >
                        {filteredCategories.length === 0 ? (
                          <div className="p-3 text-center text-muted">
                            {searchTerm ? "No categories found matching your search." : "No categories available."}
                          </div>
                        ) : (
                          filteredCategories.map((cat) => (
                            <div
                                                              key={cat.id === "" ? "all-categories" : cat.id}
                                  className={`p-3 border-bottom cursor-pointer ${
      (category === "" && cat.id === "") || (category === cat.id?.toString()) ? "" : "hover-bg-light"
    }`}
        style={{
      cursor: "pointer",
      transition: "background-color 0.2s",
      backgroundColor: (category === "" && cat.id === "") || (category === cat.id?.toString()) ? "#e9ecef" : "transparent",
    }}
          onClick={() => {
        setCategory(cat.id === "" ? "" : cat.id.toString());
        setIsDropdownOpen(false);
        setSearchTerm("");
        setHasSelected(true);
      }}
                                      onMouseEnter={(e) => {
          if ((category !== "" || cat.id !== "") && category !== cat.id?.toString()) {
            e.target.style.backgroundColor = "#f8f9fa";
          }
        }}
        onMouseLeave={(e) => {
          if ((category !== "" || cat.id !== "") && category !== cat.id?.toString()) {
            e.target.style.backgroundColor = "transparent";
          }
        }}
                            >
                              <div className="d-flex align-items-center">
                                {(cat.thumb_url || cat.id === "") && (
                                          <img
          src={cat.id === "" ? require("../../../assets/Icon/Product icon.svg").default : cat.thumb_url}
          alt={cat.name}
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                      marginRight: "12px",
                                    }}
                                  />
                                )}
                                <div>
                                  <div className="fw-bold">{cat.name}</div>
                                          {/* Only show product/stock info for real categories */}
        {cat.id !== "" && (
                                    <small className="text-muted">
                                      {cat.products} products • {cat.stock} in stock
                                    </small>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                  <div className="mt-2">
                    <small className="text-muted">
                      Selected:{" "}
                      {category !== ""
                        ? categories.find(cat => cat.id?.toString() === category)?.name
                        : "All Categories"}
                    </small>
                  </div>
                  {hasSelected && <div className="mt-3 position-relative d-inline-block">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={handleCopyUrl}
                      style={{ fontSize: "13px" }}
                    >
                      <i className="fas fa-copy me-1"></i> Copy Export URL
                    </button>
                    {copied && (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "calc(100% + 8px)",
                          left: "50%",
                          transform: "translateX(-50%)",
                          background: "#333",
                          color: "#fff",
                          padding: "4px 10px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          pointerEvents: "none",
                          zIndex: 9999,
                        }}
                      >
                        Link Copied!
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translateX(-50%)",
                            border: "5px solid transparent",
                            borderTopColor: "#333",
                          }}
                        />
                      </div>
                    )}
                  </div>}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="side-pd bord">
          <button
            onClick={handleExport}
            className="save-btn me-2 mt-2"
            style={{ background: "#000", color: "white" }}
          >
            Export Catalog
          </button>
        </div>
      </div>
    </div>
  );
};

export default CatalogExport; 